import { Head, Link, useForm } from '@inertiajs/react'
import PageHeader from '@/components/common/PageHeader'

type Props = {
  initial_email: string
}

const errorText = (error: string | string[] | undefined) => {
  if (!error) return ''
  return Array.isArray(error) ? error[0] : error
}

export default function V2SignIn({ initial_email }: Props) {
  const form = useForm({
    email: initial_email || '',
    password: '',
    remember_me: true,
  })
  const errors = form.errors as typeof form.errors & { base?: string[] }

  const submit = () => {
    form.transform((data) => ({ user: data }))
    form.post('/users/sign_in?reservation=1')
  }

  return (
    <>
      <Head title="ログイン - オンライン診療予約" />

      <div className="min-h-screen bg-white">
        <PageHeader subtitle="新規登録/ログイン" />

        <main className="mx-auto max-w-3xl px-4 py-6">
          <div className="oc-card">
            <h1 className="oc-section-title">ログイン</h1>

            {errors.base && (
              <div className="mb-4 rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-600">
                {errorText(errors.base)}
              </div>
            )}

            <div className="space-y-4">
              <div>
                <label htmlFor="user_email" className="mb-1 block text-sm font-medium text-[#2a3039]">メールアドレス</label>
                <input
                  id="user_email"
                  type="email"
                  className="oc-input"
                  value={form.data.email}
                  onChange={(e) => form.setData('email', e.target.value)}
                />
                {form.errors.email && <p className="mt-1 text-sm text-red-600">{errorText(form.errors.email)}</p>}
              </div>

              <div>
                <label htmlFor="user_password" className="mb-1 block text-sm font-medium text-[#2a3039]">パスワード</label>
                <input
                  id="user_password"
                  type="password"
                  className="oc-input"
                  value={form.data.password}
                  onChange={(e) => form.setData('password', e.target.value)}
                />
                {form.errors.password && <p className="mt-1 text-sm text-red-600">{errorText(form.errors.password)}</p>}
              </div>

              <label className="flex items-center gap-2 text-sm text-[#515862]">
                <input
                  type="checkbox"
                  className="oc-checkbox"
                  checked={form.data.remember_me}
                  onChange={(e) => form.setData('remember_me', e.target.checked)}
                />
                次回から自動ログインにする
              </label>
            </div>

            {/* ログインは既存ユーザー向けのため、新規会員登録より控えめな secondary ボタンにする */}
            <button type="button" className="button-secondary mt-6" disabled={form.processing} onClick={submit}>
              ログイン
            </button>

            <div className="mt-4 text-center text-sm">
              <a href="/users/password/new" className="oc-link">
                パスワードを忘れた方
              </a>
            </div>
          </div>

          {/* 初めてご利用の方向けの新規会員登録導線。初訪問ユーザーが迷わず登録に進めるよう、
              独立カード＋ログインより目立つ primary・太字ボタンで最も目立たせる */}
          <div className="oc-info-card mt-4 text-center">
            <p className="text-[16px] font-bold text-[#2a3039]">初めてご利用の方</p>
            <p className="mt-1 mb-4 text-sm text-[#515862]">アカウントをお持ちでない方はこちら</p>
            <Link href="/users/sign_up?reservation=1" className="button-primary font-bold">
              新規会員登録
            </Link>
          </div>
        </main>
      </div>
    </>
  )
}
